import styled, { css } from "styled-components";
import { BORDER_PRIMARY, MINESHAFT_GREY } from "@/constants/colors";
import { CONTENT_MAX_WIDTH } from "@/constants/layout";
import { PageContainer, ScrollArea } from "@/components/generic/PageLayout";

export const TableContainer = styled(PageContainer)`
  height: 100%;
`;

export const TableWrapper = styled(ScrollArea)`
  border-radius: 4px;
  box-shadow: 0px 0px 5px ${BORDER_PRIMARY};
`;

export const CreateUserButtonWrapper = styled.div`
  width: 177px;
  margin-right: 24px;
`;

export const StatusColumn = styled.div`
  min-width: 96px;
`;

export const SpinnerWrapper = styled.div`
  width: 24px;
  height: 24px;
`;

export const SpinnerOverlay = styled.td`
  height: 50px;
  width: ${CONTENT_MAX_WIDTH};
  margin-left: -${CONTENT_MAX_WIDTH};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${MINESHAFT_GREY};
  ${(props) =>
    props.isHidden &&
    css`
      visibility: hidden;
      opacity: 0;
      transition-timing-function: ease-in;
      transition-delay: 0.2s;
    `}
  ${(props) =>
    !props.isHidden &&
    css`
      visibility: visible;
      opacity: 0.4;
      transition-timing-function: ease-out;
      transition-delay: 0s;
    `}
  transition-property: visibility, opacity;
  transition-duration: 0.2s;
`;
